import React from 'react';
import Badge from '../Badge';
import Img from '../Img';

interface Tag {
    id: number;
    name: string;
    slug: string;
    icon: string;
}

interface TagsGroup {
    id: number;
    name: string;
    slug: string;
    visible: boolean;
    tags?: Tag[];
}

interface Product {
    tags?: TagsGroup[];
}

interface BoxContentTagsProps {
    product: Product;
}

const BoxContentTags = ({ product }: BoxContentTagsProps) => {

    const groups = product.tags ?? [];
    const hasVisible = groups.some((item: TagsGroup) => item.visible == true);

    if (groups.length === 0 || !hasVisible) {
        return null;
    }

    return (
        <div className="flex flex-col gap-2">
            {groups
                .filter((group) => group.visible === true)
                .map((group) => {
                    const tags = group.tags ?? [];

                    if (tags.length === 0) {
                        return null;
                    }

                    return (
                        <div key={group.id} className="flex flex-col gap-1">

                            <span className="text-xs font-semibold opacity-70">
                                {group.name}
                            </span>

                            <div className="flex flex-wrap gap-1 opacity-85">
                                {tags.map((tag) => (
                                    <Badge key={tag.id} outline className="text-xs normal-case text-nowrap font-normal px-1 gap-1 rounded-full">
                                        {tag.name}
                                    </Badge>
                                ))}
                            </div>
                        </div>
                    )
            })}
        </div>
    )
}

export default BoxContentTags;
